const honeypotFields = document.querySelectorAll('.m-form__hpfield--a');

if (honeypotFields) {
  Array.from(honeypotFields).forEach((field) => {
    field.style.display = 'none';
  });
}